<template>
  <div class="tip p15 relative" v-if="show">
    <p class="fs-12">Tips</p>
    <p class="fs-16 bold mt-10 mb-10">{{ title }}</p>
    <p class="fs-14 opaque-90" v-html="body"></p>
    <img src="../assets/icons/remove-white.svg" @click="hideTip">
    <div class="tip__arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'tip',
  data() {
    return {
      show: true
    }
  },
  props: {
    title: String,
    body: String,
    id: String,
  },
  created() {
    if (localStorage[this.id]) {
      this.show = false;
    }
  },
  methods: {
    hideTip() {
      localStorage.setItem(this.id, "1");
      this.show = false;
    }
  }
}
</script>
<style>
.tip {
  background-color: #F7921E;
  color: white;
}
.tip img {
  position: absolute;
  top: 15px;
  right: 15px;
}
.tip__arrow {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #F7921E;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
